export default __webpack_public_path__ + "static/media/rena.e83a82a7.png";